<template>
    <li v-if="isStudent" class="c-header__link--student">
        <a @click.prevent="openModal">{{ $t('accountLinking.joinClass') }}</a>
        <teleport to="#popup">
            <MathStudentMyClass
                v-if="showModal"
                :show-join-button="false"
                @closed-modals="showModal = false"
            />
        </teleport>
    </li>
</template>

<script>
import MathStudentMyClass from '@/student/widgets/MathStudentMyClass.vue';
import { isStudent } from '@/flows/Authentication/helpers/AuthHelpers.js';
import { mapGetters } from 'vuex';

export default {
    components: { MathStudentMyClass },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        ...mapGetters(['user']),
        isStudent() {
            return isStudent(this.user);
        },
    },
    methods: {
        openModal() {
            this.showModal = true;
        },
    },
};
</script>
